export default {
  'clocks': [],
  'permanentRequiredFields': [
    'RequestInterest',
    'Salutation',
    'FirstName',
    'LastName',
    'Email',
    'RequestMessage'
  ],
  'requiredFields': {
    'consulting': [
      'Company',
      'RequestTopic',
      'CompanyRegistrationNo'
    ],
    'offersGeneral': [
      'Company',
      'RequestTopic',
      'CompanyRegistrationNo'
    ],
    'customer_serviceGeneral': [
      'Company',
      'RequestTopic',
      'CompanyRegistrationNo'
    ],
    'cooperation': [
      'Company',
      'RequestTopic',
      'CompanyRegistrationNo'
    ]
  }
}
